import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';

export type EventLogClinic = {
  clinicId: number;
  clinicName: string;
  status: string;
  plan: string;
  totalEvents: number;
  activeUsers: number;
  appointments: number;
  encounters: number;
  payments: number;
};

export type EventLogEvent = {
  id: number;
  clinicId: number;
  userId: string | null;
  locationId: number | null;
  eventType: string;
  metadata: Record<string, unknown> | null;
  occurredAt: number;
  userName: string | null;
};

export type EventLogUser = {
  userId: string;
  userName: string;
  userEmail: string;
  role: string;
  metrics: Record<string, number>;
};

export type EventLogClinicSummary = {
  clinic: {
    ID: number;
    name: string;
    status: string;
    plan: string;
  } | null;
  metrics: Record<string, number>;
  periodStart: string;
  periodEnd: string;
};

const eventLogService = () => {
  const listClinics = async (params: {
    search?: string;
    skip?: number;
    limit?: number;
    startDate?: string;
    endDate?: string;
  }): Promise<{ data: EventLogClinic[]; skip?: number; count: number }> => {
    return ChiroUpAPI.get('api', '/event-logs/clinics', { queryParams: params });
  };

  const listEvents = async (
    clinicId: number,
    params: {
      skip?: number;
      limit?: number;
      eventType?: string;
      userId?: string;
      startDate?: string;
      endDate?: string;
    }
  ): Promise<{ data: EventLogEvent[]; skip?: number; count: number }> => {
    return ChiroUpAPI.get('api', `/event-logs/clinics/${clinicId}/events`, {
      queryParams: params,
    });
  };

  const listUsers = async (
    clinicId: number,
    params: {
      startDate?: string;
      endDate?: string;
    }
  ): Promise<{ data: EventLogUser[] }> => {
    return ChiroUpAPI.get('api', `/event-logs/clinics/${clinicId}/users`, {
      queryParams: params,
    });
  };

  const getClinicSummary = async (
    clinicId: number,
    params: {
      startDate?: string;
      endDate?: string;
    }
  ): Promise<EventLogClinicSummary> => {
    return ChiroUpAPI.get('api', `/event-logs/clinics/${clinicId}/summary`, {
      queryParams: params,
    });
  };

  return {
    listClinics,
    listEvents,
    listUsers,
    getClinicSummary,
  };
};

export default eventLogService();
